import { composeAPI } from "../../Common/api";
import interfaceComposition from "../composition";
import loadAndParseInterfaces, { parseRowGivenHeader } from "./interfaces";

export const rowAsProfile = parseRowGivenHeader(["name", "id"]);

const composeCellsLines = (size, separator) => (line, value, index) =>
  line +
  (index === 0
    ? value.padEnd(size + 1, separator)
    : value.padStart(size + 1, separator));

const renderIntoTable = (rows, { cellSize = 0, separator = " " }) =>
  rows
    .map((values) => values.reduce(composeCellsLines(cellSize, separator), ""))
    .join("\n") + "\n";

const maxValueLength = (max, value) =>
  max > value.length ? max : value.length;

const arrangeIntoTable = (...rows) =>
  renderIntoTable(rows, {
    cellSize: rows.flat().reduce(maxValueLength, 0),
    separator: " ",
  });

const idNotfound = (id, map) =>
  console.warn("not found", id, map) || ["notfound"];

const rowsWithProfileAndDevicesGiven =
  (interfacesById) =>
  ({ name, id }) =>
    (interfacesById[id] || idNotfound(id, interfacesById)).map((device) => [
      name,
      device,
    ]);

const translateIntoDevicesTable = (profiles, interfacesById) =>
  arrangeIntoTable(
    ["NAME", "DEVICE"],
    ...profiles.flatMap(rowsWithProfileAndDevicesGiven(interfacesById))
  );

const toIDMap = (interfaces) =>
  interfaces.reduce(
    (map, { id, name }) => ({
      ...map,
      [id]: map[id] ? [...map[id], name] : [name],
    }),
    {}
  );

export const toSetOfIdsInUse = (input) => {
  const [_head, ...lines] = input.trim("\n").split("\n");
  return new Set(lines.map(rowAsProfile).map(({ id }) => id));
};

export const translateInProfileByInteface = (input, interfaces = []) => {
  const [_head, ...lines] = input.trim("\n").split("\n");
  const profiles = lines.map(rowAsProfile);
  return translateIntoDevicesTable(profiles, toIDMap(interfaces));
};

const loadAll = () =>
  Promise.all([
    loadAndParseInterfaces(),
    ifCl.run(`show profile interface`),
  ]).then(([interfaces, response]) =>
    translateInProfileByInteface(response, interfaces)
  );

const notMatchingByFieldIn = (field, list) => (one) =>
  list.find((other) => one[field] === other[field]) === undefined;

const invalid = (cause) => {
  throw cause;
};

const nameAsInterface = ({ name }) => ({ ["interface"]: name });

const validateNotAllTaken = (settings) =>
  loadAndParseInterfaces()
    .then((interfaces) => notContainingAll(interfaces.map(nameAsInterface)))
    .then((validate) => validate(settings.interfaces))
    .catch((error) =>
      invalid(`Profile "${settings.name}" input interfaces ${error}`)
    );

const validateDevicesBeforeCommand = ({ composeProfileSettings, ...api }) => ({
  composeProfileSettings: (previous, settings) =>
    validateNotAllTaken(settings).then(() =>
      composeProfileSettings(previous, settings)
    ),
  ...api,
});

const notDeleted = ({ deleted = false }) => deleted !== true;

const notContainingAll = (all) => (list) =>
  all.find(notMatchingByFieldIn("interface", list.filter(notDeleted))) ===
  undefined
    ? invalid(`can't be all interfaces`)
    : list;

const composedAPI = validateDevicesBeforeCommand(
  composeAPI({ loadAll, ...interfaceComposition })
);

export default composedAPI;
